export default "/fonts/Flaticon.ttf?00eacf86b4318d9958a8179dea589b04";